import { render } from "./TagSelectInput.vue?vue&type=template&id=1a645a24&scoped=true"
import script from "./TagSelectInput.vue?vue&type=script&lang=js"
export * from "./TagSelectInput.vue?vue&type=script&lang=js"

import "./TagSelectInput.vue?vue&type=style&index=0&id=1a645a24&scoped=true&lang=css"
import "./TagSelectInput.vue?vue&type=style&index=1&id=1a645a24&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a645a24"]])

export default __exports__